import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { DragSource } from 'react-dnd';
import withGS from '../core/withGShoc';
import ResourceSlat from './ResourceSlat';
import ResourceStructure from './ResourceStructure';

const styles = Object.assign({
    resources: {
        marginLeft: '30px'
    }
});


const Types = {
    RESOURCE: 'resource'
};

const resourceSource = {
    beginDrag(props) {
        return {
            resourceId: props.id
        };
    }
};

function collectSource(connect) {
    return {
        connectDragSource: connect.dragSource()
    };
}

class TreeResource extends React.Component {

    state = {
        scrollTime: null
    };

    shouldComponentUpdate(nextProps) {
        if (nextProps.viewLang !== this.props.viewLang) return true;
        const firstInOldPath = this.props.selectedTitlePath.length > 0 ? this.props.selectedTitlePath[0] : null;
        const firstInNewPath = nextProps.selectedTitlePath.length > 0 ? nextProps.selectedTitlePath[0] : null;
        if (firstInOldPath === this.props.id || firstInNewPath === this.props.id) return true;
        if (nextProps.foundTime !== this.props.foundTime && nextProps.foundPath.startsWith(nextProps.path)) return true;
        const nextPropsExpansion = nextProps.expandedPaths;
        const currentPropsExpansion = this.props.expandedPaths;
        if (nextProps.version === this.props.version && nextPropsExpansion.length === currentPropsExpansion.length) return false;
        return true;
    }

    expandNode = () => this.props.expandNode(this.props.path);

    collapseNode = () => this.props.collapseNode(this.props.path);

    processExpandAndScroll() {
        if (this.props.foundRef === null || this.props.data.pendingDeletion
            || this.props.foundPath !== this.props.path
            || this.state.scrollTime === this.props.foundTime) return;
        this.setState({ scrollTime: this.props.foundTime }, () =>
            this.props.foundRef.current.scrollIntoView({
                block: 'center',
                inline: 'center',
            })
        );
    }

    componentDidMount() {
        this.processExpandAndScroll();
    }

    componentDidUpdate() {
        this.processExpandAndScroll();
    }

    render() {

        const { connectDragSource, excludeByPath, path, parentIRI, searchClass, defaultLang, ontologyIRI,
            childProperty, foundPath, foundRef, activeResource, viewLang, titleTree, useSlashIRI, useUuidIRI, iriOptions,
            classes, data, onSelect, expandedPaths, expandNode, foundTime, permissions, searchClassFilter, selectedTitlePath, titlePath,
            collapseNode, onAddNewNode, onDeleteNode, onBreakLink, createDialog, addTitle, graph, onAddExistingNode, isReadOnly } = this.props;

        if (data.pendingDeletion) return null;
        const isExpanded = data[childProperty] && data[childProperty].length > 0 && expandedPaths.includes(path);

        let label = "No label available";
        const displayLang = viewLang && data.label && data.label[viewLang] ?
            viewLang
            :
            data.label && data.label[defaultLang] ?
                defaultLang
                :
                "und";
        if (data.label && data.label[displayLang]) {
            label = Array.isArray(data.label[displayLang]) ?
                [...data.label[displayLang]].sort().join(" AND ") : data.label[displayLang];
        }

        let title = label;
        const titlePathPlus = titlePath.concat(data.id);
        let titleTreePlus = titleTree && titleTree.concat([title]);

        const slat = <div data-test={"slat-container-" + data.id}>
            <ResourceSlat
                expandNode={this.expandNode}
                collapseNode={this.collapseNode}
                isExpanded={isExpanded}
                viewLang={viewLang}
                iriOptions={iriOptions}
                ontologyIRI={ontologyIRI}
                useSlashIRI={useSlashIRI}
                useUuidIRI={useUuidIRI}                         
                defaultLang={defaultLang}
                searchClass={searchClass}
                onAddExistingNode={onAddExistingNode}
                excludeByPath={excludeByPath}
                onAddNewNode={onAddNewNode && onAddNewNode(titlePathPlus, path)}
                onBreakLink={onBreakLink}
                activeResource={activeResource}
                selectedTitlePath={selectedTitlePath}
                titlePath={titlePathPlus}
                titleTree={titleTreePlus}
                data={data}
                path={path}
                graph={graph}
                addTitle={addTitle}
                searchClassFilter={searchClassFilter}
                permissions={permissions}
                parentIRI={parentIRI}
                childProperty={childProperty}
                onSelect={onSelect}
                createDialog={createDialog}
            />
        </div>;

        return <div className={classes.slatContainer}>
            {foundRef && foundPath === path && <div ref={foundRef} />}
            {isReadOnly || (data.deprecated === true) ? slat : connectDragSource(slat)}
            {isExpanded &&
                <div data-test="node-children" className={classes.resources}>
                    <ResourceStructure
                        id={data.id}
                        version={data.version}
                        defaultLang={defaultLang}
                        permissions={permissions}
                        foundPath={foundPath}
                        foundTime={foundTime}
                        foundRef={foundRef}
                        path={path}
                        graph={graph}
                        viewLang={viewLang}
                        iriOptions={iriOptions}
                        isReadOnly={isReadOnly}
                        addTitle={addTitle}
                        titlePath={titlePathPlus}
                        titleTree={titleTreePlus}
                        searchClass={searchClass}
                        selectedTitlePath={selectedTitlePath.length > 0 && selectedTitlePath[0] === this.props.id ? selectedTitlePath.slice(1) : []}
                        activeResource={activeResource}
                        excludeByPath={excludeByPath}
                        searchClassFilter={searchClassFilter}
                        expandedPaths={expandedPaths}
                        onAddExistingNode={onAddExistingNode}
                        onAddNewNode={onAddNewNode}
                        onDeleteNode={onDeleteNode}
                        onBreakLink={onBreakLink}
                        expandNode={expandNode}
                        collapseNode={collapseNode}
                        ontologyIRI={ontologyIRI}
                        useSlashIRI={useSlashIRI}
                        useUuidIRI={useUuidIRI}                         
                        childProperty={childProperty}
                        data={data}
                        onSelect={onSelect}
                        createDialog={createDialog}
                    />
                </div>
            }
        </div>;
    }
}

TreeResource.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    ontologyIRI: PropTypes.string.isRequired,
    useSlashIRI: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    version: PropTypes.number,
    graph: PropTypes.string.isRequired,
    foundPath: PropTypes.string,
    isReadOnly: PropTypes.bool,
    path: PropTypes.string.isRequired,
    searchClass: PropTypes.string,
    excludeByPath: PropTypes.func,
    expandedPaths: PropTypes.arrayOf(PropTypes.string).isRequired,
    expandNode: PropTypes.func.isRequired,
    collapseNode: PropTypes.func.isRequired,
    onAddExistingNode: PropTypes.func.isRequired,
    onAddNewNode: PropTypes.func,
    onDeleteNode: PropTypes.func.isRequired,
    onBreakLink: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    addTitle: PropTypes.string,
    activeResource: PropTypes.string,
    childProperty: PropTypes.string.isRequired,
    parentIRI: PropTypes.string.isRequired,
    foundTime: PropTypes.number,
    foundRef: PropTypes.object,
    viewLang: PropTypes.string,
    selectedTitlePath: PropTypes.array,
    titlePath: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    permissions: PropTypes.array.isRequired,
    searchClassFilter: PropTypes.array.isRequired,
    createDialog: PropTypes.object.isRequired,
    iriOptions: PropTypes.object
};

const cpt = DragSource(Types.RESOURCE, resourceSource, collectSource)(withStyles(styles)(TreeResource));

export default withGS(cpt, ["ALL"]);